import { FC, ReactNode } from 'react'
import { RouteObject, useSearchParams } from 'react-router-dom'
import { rotasDeRedirect } from '../redirects'

// Páginas ANTIGAS renderizadas nas rotas NOVAS (renomeamos a rota, não a página).
// As páginas do Figma chegam nas rodadas 2–4 e substituem estes elementos.
import ReservasListPage from '@/pages/reservas/ReservasListPage'
import RenovacoesPage from '@/pages/renovacoes/RenovacoesPage'
import ProdutosListPage from '@/pages/produtos/ProdutosListPage'
import AgendaPage from '@/pages/agenda/AgendaPage'
import AgendamentosPendentesPage from '@/pages/agenda/AgendamentosPendentesPage'
import MeusDadosPage from '@/pages/lgpd/MeusDadosPage'
import IncidentePage from '@/pages/lgpd/IncidentePage'

/**
 * Rotas do A02 (Onda 1) — nomes novos do Figma + redirects das rotas antigas.
 *
 * Itens "absorvidos" pelo plano (renovações, candidaturas, tenants, saneamento,
 * conteúdo do 1º acesso, agendamentos pendentes) viram `?aba=` na rota nova: a
 * página antiga continua alcançável até a página consolidada existir.
 */
export const PorAba: FC<{ padrao: ReactNode; abas: Record<string, ReactNode> }> = ({ padrao, abas }) => {
  const [searchParams] = useSearchParams()
  const aba = searchParams.get('aba') ?? ''
  return <>{aba && abas[aba] !== undefined ? abas[aba] : padrao}</>
}

const rotasNovas: RouteObject[] = [
  // Minhas Reservas (consultor) — `?aba=renovacoes` preserva a fila antiga.
  {
    path: 'reservas',
    element: <PorAba padrao={<ReservasListPage />} abas={{ renovacoes: <RenovacoesPage /> }} />,
  },
  // Reservas e Curadoria (back-office): entregue pelo A11 (`rotas/a11.tsx`, `?aba=renovacoes` preservado lá).
  // Agenda — `?aba=pendentes` = antiga /agenda/pendentes (back-office).
  {
    path: 'agenda',
    element: <PorAba padrao={<AgendaPage />} abas={{ pendentes: <AgendamentosPendentesPage /> }} />,
  },
  // Pipeline Comercial: entregue pelo A10 (`rotas/a10.tsx`, por persona).
  // Operações e Clientes / Pendências e Documentos: entregues pelo A04 (`rotas/a04.tsx`, mesmos `?aba=`).
  // Simulações: entregue pelo A15 (`rotas/a15.tsx`; o simulador genérico segue atrás da flag em `?aba=simulador`).
  // Produtos e Materiais (consultor).
  { path: 'produtos-materiais', element: <ProdutosListPage /> },
  // Documentos e Materiais / Parceiros (back-office): entregues pelo A12 (`rotas/a12.tsx`).
  // Usuários (consultor): auto-visão entregue pelo A16 (`rotas/a16.tsx`; `?aba=perfil` preservado lá).
  // Usuários e Acessos (ADMIN): entregue pelo A05 (`rotas/a05.tsx`, mesmos `?aba=`).
  // Meus Dados / Reportar Incidente (consultor) — antigas /lgpd/*.
  { path: 'meus-dados', element: <MeusDadosPage /> },
  { path: 'reportar-incidente', element: <IncidentePage /> },
]

const rotasA02: RouteObject[] = [...rotasNovas, ...rotasDeRedirect()]

export default rotasA02
